'use client';

import { type FC, useEffect, useState } from 'react';
import type { MenuProps } from '@/components/general/Menu';
import { useFixedHeader } from '@/hooks/header';
import { usePopupHeight } from '@/hooks/usePopupHeight';
import { usePromotionsMenuData } from '@/modules/promotions';
import { ScHeaderDesktop } from '../styled';
import { HeaderContent } from './HeaderContent';

interface HeaderDesktopProps extends MenuProps {
  locale: string;
}

const WIDE_HEADER_TOP_OFFSET = 84;

export const HeaderDesktop: FC<HeaderDesktopProps> = ({
  locale,
  links,
  moreLinks,
}) => {
  const isFixedHeader = useFixedHeader(locale);
  const [wideHeader, setIsWideHeader] = useState(false);
  const { popupHeight } = usePopupHeight();

  useEffect(() => {
    setIsWideHeader(!isFixedHeader);
  }, [isFixedHeader]);

  useEffect(() => {
    if (isFixedHeader) {
      const handleScroll = () => {
        if (window?.scrollY > WIDE_HEADER_TOP_OFFSET && !wideHeader) {
          setIsWideHeader(true);
        } else if (window?.scrollY < WIDE_HEADER_TOP_OFFSET && wideHeader) {
          setIsWideHeader(false);
        }
      };

      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [isFixedHeader, wideHeader, setIsWideHeader]);

  usePromotionsMenuData({ locale });

  return (
    <ScHeaderDesktop
      $popupHeight={popupHeight}
      isFixedHeader={isFixedHeader}
      wide={wideHeader}
    >
      <HeaderContent links={links} locale={locale} moreLinks={moreLinks} />
    </ScHeaderDesktop>
  );
};
